module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('button', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        _vm.$store.commit('menu/menuToggle')
      }
    }
  }, [(_vm.menu) ? _c('i', {
    staticClass: "fas fa-times"
  }) : _c('i', {
    staticClass: "fas fa-bars"
  })]), _vm._v(" "), _c('h3', [_vm._v("Old Header Title")]), _vm._v(" "), _c('button', {
    staticClass: "exit",
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("X")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa4a795"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = 129
// module chunks = 0